import React, { Children, memo } from 'react';
import { motion } from 'framer-motion';
export function BeneficiosSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.1
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -10
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.4,
        ease: 'easeOut'
      }
    }
  };
  const benefits = [{
    emoji: '🌟',
    text: <>
          Estimular su{' '}
          <span className="font-semibold" data-id="element-12">desarrollo sensorial y motor</span>
        </>
  }, {
    emoji: '🧠',
    text: <>
          Mejorar su{' '}
          <span className="font-semibold" data-id="element-13">lenguaje y vocabulario</span>
        </>
  }, {
    emoji: '🎯',
    text: <>
          Potenciar su{' '}
          <span className="font-semibold" data-id="element-14">
            atención, concentración y memoria
          </span>
        </>
  }, {
    emoji: '🎨',
    text: <>
          Activar su{' '}
          <span className="font-semibold" data-id="element-15">
            curiosidad, creatividad y percepción visual
          </span>
        </>
  }, {
    emoji: '🤝',
    text: <>
          Reforzar el{' '}
          <span className="font-semibold" data-id="element-16">
            vínculo emocional entre tú y tu hijo(a)
          </span>
        </>
  }, {
    emoji: '📚',
    text: <>
          Promover el aprendizaje temprano <em data-id="element-17">sin pantallas</em>
        </>
  }, {
    emoji: '✨',
    text: <>
          Incluir temas esenciales como: familia, animales, colores, números,
          emociones, formas, alimentos, naturaleza, buenas conductas y más ✨
        </>
  }];
  return <section className="w-full bg-gradient-to-br from-blue-50 via-yellow-50 to-pink-50 py-6 px-4 md:py-16 overflow-hidden" data-id="element-18">
      <motion.div className="max-w-md md:max-w-2xl mx-auto text-center" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
      once: true,
      amount: 0.2
    }} data-id="element-19">
        <motion.div variants={cardVariants} className="bg-white rounded-2xl shadow-lg p-5 md:p-8 border border-blue-200" data-id="element-20">
          <h2 className="text-xl md:text-2xl font-extrabold text-blue-800 uppercase mb-4 tracking-tight" data-id="element-21">
            🎯 Beneficios poderosos del libro
          </h2>

          <motion.ul className="text-left text-base md:text-lg text-gray-800 leading-relaxed space-y-3" variants={containerVariants} data-id="element-22">
            {benefits.map((benefit, index) => <motion.li key={index} variants={itemVariants} data-id="element-23">
                {benefit.emoji} {benefit.text}
              </motion.li>)}
          </motion.ul>
        </motion.div>
      </motion.div>
    </section>;
}